import { TaskTargetResource } from "../types/types";

export const isTaskTargetResource = (
  target: any,
): target is TaskTargetResource => {
  return !!target?.resources;
};
